import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'
import tabBar from '@componentsG/tabBar'
import {Button, WhiteSpace, Modal} from 'antd-mobile'
import {FormattedMessage} from 'react-intl'
import DeviceIcon from '@assets/img/mine/device.png'
import PackageIcon from '@assets/img/mine/package.png'
import OrderIcon from '@assets/img/mine/order.png'
import AccountIcon from '@assets/img/global/account.png'
import DefaultAvatarIcon from '@assets/img/global/default-avatar.png'
import FaqIcon from '@assets/img/global/icon_faq.png'
import ContactIcon from '@assets/img/global/icon_contactus.png'
import RightArrowIcon from '@assets/img/icon_arrow.png'
import * as styles from './style/index.scss'
import intl from '@utils/intl'

const alert = Modal.alert;
const basePath = '/global/'

@inject('meStoreG')
@observer
class Me extends ComponentExt<any> {
    private store: any
    private readonly userInfo: any = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    private navList = [
        {iconUrl: DeviceIcon, path: basePath + 'myDevice', chinese: '设备', messageId: 'me.nav.device'},
        {iconUrl: PackageIcon, path: basePath + 'myDataPlan', chinese: '我的套餐', messageId: 'me.nav.package'},
        {iconUrl: OrderIcon, path: basePath + 'myOrder', chinese: '订单', messageId: 'me.nav.order'},
        {iconUrl: AccountIcon, path: basePath + 'accountInfo', chinese: '账号信息', messageId: 'me.nav.accountInfo'},
        {iconUrl: FaqIcon, path: basePath + 'FAQ', chinese: 'FAQ', messageId: 'me.nav.FAQ'},
        {iconUrl: ContactIcon, path: basePath + 'contactUs', chinese: '联系我们', messageId: 'me.nav.contactUs'}
    ]

    constructor(props) {
        super(props)
        this.store = props.meStoreG
    }

    signOut = () => {
        const title = intl.formatMessage({id: 'me.signOut.alert.title'})
        const content = intl.formatMessage({id: 'me.signOut.alert.content'})
        const OK = intl.formatMessage({id: 'common.sure'})
        const cancel = intl.formatMessage({id: 'common.cancel'})
        alert(title, content, [
            {text: cancel},
            {text: OK, onPress: () => this.store.signOut()}
        ])
    }

    render() {
        const {lenovoId, laoCustomerDto = {}} = this.userInfo
        if (!lenovoId) {
            return (
                <Redirect to={'/global/login'}/>
            )
        }
        return (
            <>
                <section className={styles.userInfoWrap}>
                    <div className={styles.userInfoInnerWrap}>
                        <img className={styles.avatar} src={DefaultAvatarIcon}/>
                        <div>
                            <p className={styles.lenovoId}>{lenovoId}</p>
                            <p className={styles.nickName}>{laoCustomerDto.nickName || lenovoId}</p>
                        </div>
                    </div>
                    <Button className={styles.signOutBtn} onClick={this.signOut}>
                        <FormattedMessage id="me.signOut"/>
                    </Button>
                </section>
                <WhiteSpace className={styles.whiteSpace}/>
                <nav className={styles.navWrap}>
                    {
                        this.navList.map(item => (
                            <li
                                className={styles.navItem}
                                key={item.messageId}
                                onClick={() => this.goToPath(item.path)}
                            >
                                <img src={item.iconUrl} className={styles.navItemIcon}/>
                                <div className={styles.rightInfoWrap}>
                                    <FormattedMessage id={item.messageId}/>
                                    <img src={RightArrowIcon} className={styles.rightArrow}/>
                                </div>
                            </li>
                        ))
                    }
                </nav>
            </>
        )
    }
}

export default tabBar(Me)
